<template>
  <div class="container">
    <loading :active.sync="loading"></loading>
    <div v-if="initialized">
      <app-inventory-block-select @inventoryBlockChanged="inventoryBlock = $event"></app-inventory-block-select>
      <h4 class="title">Укажите даты и количество гостей</h4>
      <div class="row">
        <app-date-picker @dateRangeChanged="dateRange=$event"></app-date-picker>
        <app-guest-select :inventoryBlock="inventoryBlock" @guestCountChanged="guestCount=$event"
                          v-if="inventoryBlock"></app-guest-select>
      </div>
      <app-inventory-type-select
        :dateRange="dateRange"
        :inventoryBlock="inventoryBlock"
        :guestCount="guestCount"
        :inventoryTypePrices="inventoryTypePrices"
        @roomRatesChanged="roomRates=$event"
        @inventoryTypeChanged="inventoryType=$event"
        @contactInfoChanged="contactInfo=$event"
        @guestsChanged="guests=$event"
        @totalAmountChanged="totalAmount=$event"
        @createReservation="createReservation()"
      ></app-inventory-type-select>
      <app-get-price
        :dateRange="dateRange"
        :inventoryBlock="inventoryBlock"
        :guestCount="guestCount"
        @ratePlanChanged="ratePlan=$event"
        @inventoryTypePricesChanged="inventoryTypePrices=$event"
      ></app-get-price>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex';
import Loading from 'vue-loading-overlay';
import store from '../../store/index';
import InventoryBlockSelect from '../booking/InventoryBlockSelect.vue';
import DatePicker from './DatePickerV2.vue';
import GuestSelect from '../booking/GuestSelect.vue';
import InventoryTypeSelect from './InventoryTypeClientSelect.vue';
import GetPrice from './GetPrice.vue';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  data() {
    return {
      inventoryBlock: null,
      dateRange: null,
      guestCount: [],
      inventoryType: null,
      roomRates: null,
      totalAmount: null,
      contactInfo: null,
      guests: null,
      extraServices: null,
      inventoryTypePrices: null,
      loading: false,
    };
  },
  components: {
    appInventoryBlockSelect: InventoryBlockSelect,
    appDatePicker: DatePicker,
    appGuestSelect: GuestSelect,
    appInventoryTypeSelect: InventoryTypeSelect,
    appGetPrice: GetPrice,
    Loading,
  },
  store,
  mounted() {
    this.$store.dispatch('init');
  },
  methods: {
    createReservation() {
      this.loading = true;
      const request = {
        employee: null,
        inventory_block: this.inventoryBlock,
        global_info: this.contactInfo,
        room_stays: [
          {
            inventory_type: this.inventoryType,
            date_from: moment(this.dateRange.date_from).format('YYYY-MM-DD'),
            date_to: moment(this.dateRange.date_to).format('YYYY-MM-DD'),
            total_amount: this.totalAmount,
            guests: this.guests,
            guest_count: this.guestCount,
            room_rates: this.roomRates,
          },
        ],
      };
      axios.post('/api/reservations/', request)
        .then((response) => {
          this.loading = false;
          if (response.status === 201) {
            this.$swal({
              title: 'Успешно забронировано',
              text: 'Бронь успешно создана!',
              type: 'success',
              timer: 5000,
            });
            this.mutateReservation(true);
            this.mutateInventoryType(null);
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 400) {
            this.$swal({
              title: 'Ошибка бронирования!',
              text: 'Бронь не может быть создана. '.concat(error.response.data.detail),
              type: 'error',
              timer: 10000,
            });
          } else {
            this.$swal({
              title: 'Ошибка бронирования!',
              text: 'Произошла непредвиденная ошибка при бронировании: '.concat(error),
              type: 'error',
              timer: 10000,
            });
          }
        });
    },
    ...mapMutations([
      'mutateReservation',
      'mutateInventoryType',
    ]),
  },
  watch: {
    roomRates() {
      console.log(this.roomRates);
    },
  },
  computed: {
    ...mapGetters(['initialized']),
  },
};
</script>
